import { create } from "zustand";
import { getAll } from "../services/service";
export const useCommentaireStore = create((set) => ({
  loading: false,
  data: [],
  count: 1,
  getData: async (url, param, otherParam) => {
    set({
      loading: true,
      data: [],
      count: 1,
    });

    try {
      const getItems = await getAll(url, param, otherParam);
      set({
        loading: false,
        data: getItems.data,
        count: getItems.data.totalPages,
      });
    } catch (error) {
      set({
        loading: true,
        data: [],
        count: 1,
      });
    }
  },
}));
